// import React, { Component, useEffect } from "react";
// import { connect } from "react-redux";
// import { Navigate } from "react-router";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { firebase } from "../../config/fb_config";

// function MyClassComponentWithNavigation(props) {
//   const navigate = useNavigate();
//   const { auth, profile, history } = props;

//   useEffect(() => {
//     if (!auth?.isLoaded) return;

//     const fetchUser = async () => {
//       try {
//         if (auth?.uid) {
//           const doc = await firebase
//             .firestore()
//             .collection("user")
//             .doc(auth.uid)
//             .get();

//           const userData = doc.data();

//           if (userData?.user_type === "requestor") {
//             navigate("/dashboard");
//           } else {
//             navigate(
//               userData?.status === "New"
//                 ? "/documents"
//                 : "/collector_dashboard",
//             );
//           }
//         } else {
//           navigate("/home");
//         }
//       } catch (err) {
//         console.log(err);
//       }
//     };

//     fetchUser();
//   }, [auth?.isLoaded, auth?.uid]);

//   // useEffect(() => {
//   //   if (!auth?.isLoaded) return;

//   //   if (auth && auth.uid) {
//   //     firebase
//   //       .firestore()
//   //       .collection("user")
//   //       .doc(auth.uid)
//   //       .get()
//   //       .then((doc) => {
//   //         const userData = doc.data();

//   //         if (userData?.user_type === "requestor") {
//   //           navigate("/dashboard");
//   //         } else {
//   //           if (userData?.status === "New") navigate("/documents");
//   //           else navigate("/collector_dashboard");
//   //         }
//   //       });
//   //   } else {
//   //     navigate("/home");
//   //   }
//   // }, [auth, navigate]);
//   return <div>Loading...</div>;
// }

// const mapStateToProps = (state) => {
//   return {
//     auth: state.firebase.auth,
//     profile: state.firebase.profile,
//   };
// };

// export default connect(mapStateToProps)(MyClassComponentWithNavigation);

import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { firebase } from "../../config/fb_config";

function MyClassComponentWithNavigation(props) {
  const navigate = useNavigate();
  const { auth } = props;

  useEffect(() => {
    // Wait until Firebase auth finishes loading
    if (!auth?.isLoaded) return;

    const checkUser = async () => {
      try {
        if (auth?.uid) {
          const doc = await firebase
            .firestore()
            .collection("user")
            .doc(auth.uid)
            .get();

          const userData = doc.data();

          if (userData?.user_type === "requestor") {
            navigate("/dashboard");
          } else {
            if (userData?.status === "New") {
              navigate("/documents");
            } else {
              navigate("/collector_dashboard");
            }
          }
        } else {
          navigate("/home");
        }
      } catch (err) {
        console.log("Firestore error:", err);
        navigate("/home");
      }
    };

    checkUser();
  }, [auth?.isLoaded, auth?.uid, navigate]);

  return <div>{!auth?.isLoaded ? "Loading..." : null}</div>;
}

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
});

export default connect(mapStateToProps)(MyClassComponentWithNavigation);
